import React from 'react';
import styles from './RotatableChevron.scss';
import { bool } from 'prop-types';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import classNames from 'classnames';

export default function RotatableChevron({ up }) {
  return (
    <ChevronDown
      className={classNames({
        [styles.chevron]: true,
        [styles.up]: up,
      })}
    />
  );
}

RotatableChevron.displayName = 'RotatableChevron';
RotatableChevron.propTypes = {
  up: bool,
};
